import { useQuery } from "@tanstack/react-query";
import { apiRelLeiturasForaPadrao } from "pages/relatorios/api/apiRelLeiturasForaPadrao";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import type { ApiRelForaPadraoGrupo } from "pages/relatorios/types/ApiRelForaPadrao";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { FilterBar } from "./FilterBar";
import { columnsGrupo, TableRelForaPadrao } from "./TableRelForaPadrao";

export function RelatorioForaPadrao() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelLeiturasForaPadrao", params],
		queryFn: () => apiRelLeiturasForaPadrao({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	const csvData: TExportToCSV<ApiRelForaPadraoGrupo> = useMemo(() => {
		return {
			type: "default",
			fileName: "relatorio-fora-padrao",
			options: {
				columns: columnsGrupo(20),
				data: registros,
			},
		};
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados das leituras foras do padrão";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Leituras Fora do Padrão"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={data?.registros || []}
			table={<TableRelForaPadrao data={data} title={title} />}
		/>
	);
}
